import { render, staticRenderFns } from "./AulasConfirmadasLancadas.vue?vue&type=template&id=afa9fdb6&scoped=true&"
import script from "./AulasConfirmadasLancadas.vue?vue&type=script&lang=js&"
export * from "./AulasConfirmadasLancadas.vue?vue&type=script&lang=js&"
import style0 from "./AulasConfirmadasLancadas.vue?vue&type=style&index=0&id=afa9fdb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa9fdb6",
  null
  
)

export default component.exports